// extracted by mini-css-extract-plugin
export default {"AccordItem":"Accordion_AccordItem__YkF5R","AccordItemHead":"Accordion_AccordItemHead__huPVY"};